import { useEffect, type FC } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetWebhook } from "@/queries/webhook-queries";
import { webhooksUrl } from "@/utils/automations";
import { WebhookDetailsDialog } from "@/components/webhooks/WebhookDetailsDialog";
import { useGoBack } from "@/hooks/use-go-back";

export const WebhookDetailsPage: FC = () => {
    const { webhookId } = useParams<{ webhookId: string }>();
    const navigate = useNavigate();
    const goBack = useGoBack(webhooksUrl());
    const { data: webhook, error, isLoading } = useGetWebhook(webhookId);

    // Redirect to webhooks list if webhook not found
    useEffect(() => {
        if (error) {
            navigate(webhooksUrl(), { replace: true });
        }
    }, [error, navigate]);

    return <WebhookDetailsDialog webhook={webhook} open={true} onClose={goBack} isLoading={isLoading} />;
};
